module.exports = __webpack_public_path__ + "img/Still-Thinking-Inspect-Portrait.5ddd02bd.png";